export default __webpack_public_path__ + "static/media/conveyor_belt.b3fbb04e.svg";